import { Box as PortalWrapperRef, Modal as MuiModal } from '@mui/material';

import type { ModalProps } from '@mui/material';
import type { FC } from 'react';

export const MODAL_TEST_ID = 'modal';

// TODO: TBD maybe rewrite to Dialog
export const Modal: FC<ModalProps> = ({ children, ...props }) => (
  <MuiModal data-testid={MODAL_TEST_ID} {...props}>
    <PortalWrapperRef sx={{ display: 'flex', placeContent: 'center' }}>
      {children}
    </PortalWrapperRef>
  </MuiModal>
);
